<template>
  <div
    class="flex flex-col rounded-lg duration-500 overflow-hidden divide-y bg-white transform transition hover:scale-105 shadow"
  >
    <div class="flex-shrink-0 relative">
      <img
        class="h-48 w-full object-cover hover:opacity-50"
        :src="baseUrlSrc(data && data.thumbnail_url)"
        alt=""
        @error="defaultImage"
      />
      <div
        class="absolute flex inset-0 justify-center items-center bg-white hover:opacity-100 opacity-0 bg-opacity-50"
      >
        <button class="bg-green-light rounded-md p-3 text-white">
          {{ currentPath === "/user/sessions" ? "Start" : "Find a " }}
          {{ data.course_id == null ? "Class" : "Course" }}
        </button>
      </div>
      <div
        class="absolute bottom-0 m-2 px-2 py-1 bg-white rounded text-gray-dark text-xs flex items-center space-x-2"
        v-if="false"
      >
        <div class="flex items-center space-x-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 text-green-light"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5.636 18.364a9 9 0 010-12.728m12.728 0a9 9 0 010 12.728m-9.9-2.829a5 5 0 010-7.07m7.072 0a5 5 0 010 7.07M13 12a1 1 0 11-2 0 1 1 0 012 0z"
            />
          </svg>
          <span class="font-semibold">LIVE</span>
        </div>
        <p>0 Viewers</p>
      </div>
      <div class="absolute top-0 right-0 m-2" v-if="false">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 text-green-light"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5.636 18.364a9 9 0 010-12.728m12.728 0a9 9 0 010 12.728m-9.9-2.829a5 5 0 010-7.07m7.072 0a5 5 0 010 7.07M13 12a1 1 0 11-2 0 1 1 0 012 0z"
          />
        </svg>
      </div>
    </div>
    <div class="flex-1 p-4 flex flex-col justify-between">
      <div class="mt-2 flex">
        <div class="flex-shrink-0">
          <a href="#">
            <span class="sr-only">Brenna Goyette</span>
            <img
              class="h-8 w-8 rounded-full"
              :src="baseUrlSrc(trainerImage)"
              alt=""
              @error="defaultImage"
            />
          </a>
        </div>
        <div class="ml-2 w-full">
          <p class="text-base font-semibold text-blackgrey capitalize mb-1">
            <!-- <a href="#" class="hover:underline"> -->
            {{ handleStr(data && data.title, 30) }}
            <!-- </a> -->
          </p>
          <div
            class="flex space-x-1 text-sm text-gray-dark items-center justify-between capitalize pr-4"
          >
            <p class="text-blackgreylight text-xs">
              {{ (trainerName) || "Trainer Name" }}
            </p>
            <div class="flex items-center text-xs">
              <Star />
              <span class="text-blackgreylight text-xs ml-2">
                {{ (data && data.avg_rating) || "0" }}
                ({{ (data && data.total_rating) || "0" }})
              </span>
            </div>
          </div>
          <div class="flex-1">
            <!-- <a href="#" class="block mt-2"> -->
            <p class="mt-3 text-xs text-green-light space-x-3">
              <span>
                {{ data && data.category }}
                {{ data && data.category_name }}
              </span>
              <span>
                {{ (data && data.language_name) || "-" }}
              </span>
            </p>
            <!-- </a> -->
          </div>
        </div>
      </div>
    </div>
    <div v-if="showDateTime == true" class="px-4 ml-10">
      <p
        class="text-xs text-gray-light ring-1 py-1 px-2 rounded-lg ring-gray-200"
      >
        {{ formatDateTime(data.start_date, "MMM D, YYYY") }}
        {{ handleHour12(data.start_date) }} - {{ handleHour12(data.end_date) }}
      </p>
    </div>
    <div
      class="flex-1 px-4 py-3 flex items-center justify-between border-t-default border-gray-light border-opacity-25"
    >
      <button
        @click="(e)=>handlePostLike(e, data.id)"
        class="text-xs text-gray-dark focus:outline-none"
        v-if="data.is_favourite == 'yes'"
      >
        <HeartFill />
      </button>
      <button
        @click="(e)=>handlePostLike(e, data.id)"
        class="text-xs text-gray-dark focus:outline-none"
        v-else
      >
        <Heart />
      </button>
      <!-- mt-2 -->
      <div
        class="flex items-center space-x-1 text-gray-light text-sm"
        v-if="data.course_id"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
          />
        </svg>
        <p class="pl-1">
          {{ data.no_of_sessions }}
          {{ data.no_of_sessions > 1 ? "SESSIONS" : "SESSION" }}
        </p>
      </div>
      <p class="text-xs text-gray-light uppercase" v-else>
        Starting at ${{ intToFloat(data && data.cost, 2) }}
      </p>
    </div>
  </div>
</template>

<script>
import { Heart, HeartFill, Star } from "@/components/icons";
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "SessionCard",
  components: {
    Heart,
    HeartFill,
    Star,
  },
  props: {
    data: {
      type: Object,
    },
    showDateTime: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters(["userSessionDetail"])
  },
  data() {
    return {
      currentPath: "",
      trainerImage: this.data && this.data.trainer_thumbnail_url,
      trainerName: this.data && this.data.trainer_name,
    };
  },
  methods: {
    ...mapActions([
      "postUserSessionAddRemoveFavourite",
      "getUserSessionDetail",
      "getUserTrendingSessions"
    ]),
    
    async handlePostLike(e, id) {
      e.preventDefault()

      let favourite;
      if(this.data.is_favourite==="yes") favourite="no"
      else favourite="yes"

      const data = {
        favourite: favourite,
        entity_id: this.data.session_id || this.data.course_id,
        post_id: id,
        entity_type: this.data.entity_type || 1
      };
      await this.postUserSessionAddRemoveFavourite(data);
      await this.getUserSessionDetail(data.entity_id);
      
      if(this.data.course_id){
        this.data.is_favourite=this.data.is_favourite==='yes'?'no':'yes'
      }
      else{
        this.data.is_favourite=this.userSessionDetail && this.userSessionDetail.session && this.userSessionDetail.session.details.is_favourite;
        this.data.is_favourite=this.data.is_favourite===false?'no':'yes'
        this.trainerImage = this.userSessionDetail && this.userSessionDetail.trainer && this.userSessionDetail.trainer.details && this.userSessionDetail.trainer.details.thumbnail_url
        this.trainerName = this.userSessionDetail && this.userSessionDetail.trainer && this.userSessionDetail.trainer.details && this.userSessionDetail.trainer.details.name
      }
    },
  },
  created() {
    this.currentPath = this.$router.currentRoute.path;
  },
};
</script>
<style lang="scss" scoped>
.shadow {
  filter: drop-shadow(0px 24px 34px rgba(0, 0, 0, 0.07));
}
</style>